import React, { useState, useEffect, useContext } from 'react';
import { Plus, Calendar, ChevronDown, Save, Ban, ChevronRight } from 'lucide-react';
import WeekComponent from '../../components/newProgramDetails/WeekComponent';
import CopyMoveModal from '../../components/newProgramDetails/CopyMoveModal';
import ExtendPlanModal from '../../components/newProgramDetails/ExtendPlanModal';
import UnsavedChangesModal from '../../components/newProgramDetails/UnsavedChangesModal';
import ActivityPickerModal from '../../components/newProgramDetails/ActivityPickerModal';
import ViewerModal from '../../components/newProgramDetails/ViewerModal';
import PatientSearchInput from '../../components/newProgramDetails/PatientSearchInput';
import GenerateScheduleModal from '../../components/newProgramDetails/GenerateScheduleModal';
import { ProgramContext } from '../../context/ProgramsContext';
import "./NewProgramDetails.css"
import axios from 'axios';
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams, UNSAFE_NavigationContext } from 'react-router-dom';
import EditPtSessionModal from '../../components/newProgramDetails/EditPtSessionModal';
import ViewPtSessionModal from '../../components/newProgramDetails/ViewPtSessionModal';
import ViewRomTestModal from '../../components/newProgramDetails/ViewRomTestModal';
import ProgramWeeksInput from '../../components/newProgramDetails/ProgramWeeksInput';
import UnassignedWarningModal from '../../components/newProgramDetails/UnassignedWarningModal';
import EditROMTestModal from '../../components/newProgramDetails/EditROMTestModal';
import CopyDayModal from '../../components/newProgramDetails/CopyDayModal';

export default function NewProgramDetails(props) {
    const { id, patientId, patientName } = useParams()
    const navigate = useNavigate();
    const ABLE_TO_CREATE_NEW_PROGRAMS = false;
    const {
        mockApi,
        today,
        ensureDateObject,
        addDays,
        isPast,
        generateUniqueId,
        checkDataLoaded,
        headerData,
        setHeaderData,
        subProblems,
        plan,
        setPlan,
        transformProgramToTaskData,
        programId,
        setProgramId,
        reverseTaskDataToProgram,
        editPtSession,
        viewPtSession,
        setViewPtSession,
        initialPlan,
        setInitialPlan,
        emptyProgramData,
        cpgProtocols,
        isTemplate,
        setIsTemplate,
        setCpgProtocols,
        setSubProblems,
        problemAreas,
        viewRomTest,
        setViewRomTest,
        editROMTest,
        showCopyModal
    } = useContext(ProgramContext)
    const [isDirty, setIsDirty] = useState(false);
    const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
    const [showCancelPrompt, setShowCancelPrompt] = useState(false);
    const [problemAreaData, setProblemAreaData] = useState(null);
    const [activityLibrary, setActivityLibrary] = useState(null);
    const [pickerState, setPickerState] = useState({ isOpen: false, dayId: null });
    const [viewerItem, setViewerItem] = useState(null);
    const [copyMoveState, setCopyMoveState] = useState({ isOpen: false, draggedData: null, targetDayId: null });
    const [extendModalOpen, setExtendModalOpen] = useState(false);
    const [genModalOpen, setGenModalOpen] = useState(false);
    const [pendingAction, setPendingAction] = useState({ type: null, weekId: null });
    const [isSaving, setIsSaving] = useState(false);
    const [pendingNavigationTarget, setPendingNavigationTarget] = useState(null);
    const [tempLength, setTempLength] = useState(headerData.planLength);
    const [loadingProgramViaPatientId, setLoadingProgramViaPatientId] = useState(false);
    const location = useLocation();
    const [showUnAssignedModal, setShowUnAssignedModal] = useState(false);


    useEffect(() => {
        localStorage.setItem("isDirty", isDirty)
        const handleBeforeUnload = (e) => {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = '';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isDirty]);

    useEffect(() => {
        if (checkDataLoaded?.patients && patientId && patientName) {
            const updatedHeaderData = {
                ...headerData,
                patientId: patientId,
                patientName: patientName
            };

            setHeaderData(updatedHeaderData);
            setPlan({ weeks: [] });

            setInitialPlan(JSON.parse(JSON.stringify({
                ...updatedHeaderData,
                weeks: [],
            })));

            setIsDirty(false);
            window.history.pushState(null, '', `/newprogram`);
        }
    }, [patientId, checkDataLoaded?.patients]);


    useEffect(() => {
        if (location?.pathname === "/newtemplate") {
            setIsTemplate(true)
        } else if (location?.pathname?.includes("protocols")) {
            setIsTemplate(true)
        } else {
            setIsTemplate(false)
        }

        console.log("location?.pathname", location?.pathname)
    }, [location?.pathname])

    useEffect(() => {
        setTempLength(headerData.planLength);
    }, [headerData.planLength]);


    const [loadingProgramData, setLoadingProgramData] = useState(true);

    // FETCH PREV PROGRAM DATA IF EDIT PROGRAM
    useEffect(() => {
        if (id && !headerData?.patientId) {
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            axios
                .post(window.ajaxLink + "cloud_programs/programs-details", { id })
                .then((res) => {
                    if (res.data.responseData) {
                        if (res.data.responseData.autocreated === true) {
                            navigate(`/newprogram/${res.data.responseData.patient_id}/${res.data.responseData.patient_name}`)
                            return;
                        }
                        let transformedData = {}
                        console.log("res.data.responseData", res.data.responseData)
                        if (res.data.responseData?.is_template) {
                            setIsTemplate(true)
                            transformedData = reverseTaskDataToProgram({ ...res.data.responseData, template_id: parseInt(id) }, res.data.responseData?.is_template)
                        } else {
                            transformedData = reverseTaskDataToProgram({ ...res.data.responseData, template_id: parseInt(id) })
                        }
                        const headerDataObject =
                        {
                            patientId: transformedData?.patientId,
                            patientName: transformedData?.patientName,
                            problemArea: transformedData?.problemArea,
                            problemId: transformedData?.problemId,
                            protocol: transformedData?.protocol,
                            subtype: transformedData?.cpgProtocol ? transformedData?.subtype : "",
                            subtypeId: transformedData?.cpgProtocolId ? transformedData?.subtypeId : 0,
                            status: transformedData?.status,
                            startDate: transformedData?.startDate,
                            planLength: transformedData?.planLength,
                            totalReward: transformedData?.totalReward,
                            programName: transformedData?.programName,
                            cpgProtocol: transformedData?.cpgProtocol,
                            cpgProtocolId: transformedData?.cpgProtocolId,
                            is_in_progress: transformedData?.is_in_progress
                        }
                        setHeaderData(headerDataObject)
                        setPlan({
                            weeks: transformedData?.weeks
                        })
                        setInitialPlan(JSON.parse(JSON.stringify({
                            weeks: transformedData?.weeks,
                            ...headerDataObject
                        })));
                        setIsDirty(false)
                        setProgramId(id)
                    }
                })
                .catch((error) => {
                    console.log(error);
                    navigate("/newprogram")
                })
                .finally(() => {
                    setLoadingProgramData(false)
                });
        } else if ((headerData?.patientId && !isTemplate) && !ABLE_TO_CREATE_NEW_PROGRAMS) {
            setLoadingProgramViaPatientId(true);
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            axios
                .post(window.ajaxLink + "cloud_programs/get-previous-patient-program-details", { patientId: headerData?.patientId })
                .then((res) => {
                    let data = res.data.responseData;
                    if (data) {
                        // console.log("res.data.responseData", data)
                        const transformedData = reverseTaskDataToProgram(data)
                        const headerDataObject = {
                            patientId: transformedData?.patientId,
                            patientName: transformedData?.patientName,
                            problemArea: transformedData?.problemArea,
                            problemId: transformedData?.problemId,
                            protocol: transformedData?.protocol,
                            subtype: transformedData?.cpgProtocol ? transformedData?.subtype : "",
                            subtypeId: transformedData?.cpgProtocolId ? transformedData?.subtypeId : 0,
                            status: transformedData?.status,
                            startDate: transformedData?.startDate,
                            planLength: transformedData?.planLength,
                            totalReward: transformedData?.totalReward,
                            programName: transformedData?.programName,
                            templateId: transformedData?.template_id,
                            cpgProtocol: transformedData?.cpgProtocol,
                            cpgProtocolId: transformedData?.cpgProtocolId,
                        }
                        setHeaderData(headerDataObject)
                        setPlan({
                            weeks: transformedData?.weeks
                        })
                        setInitialPlan(JSON.parse(JSON.stringify({
                            weeks: transformedData?.weeks,
                            ...headerDataObject
                        })));
                        setIsDirty(false)
                        if (data?.program_id) {
                            setProgramId(data?.program_id)
                            window.history.pushState(null, '', `/details/${data?.program_id}`);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    toast("This user doesn't have a previous recovery plan.");
                    emptyProgramData()
                    window.history.pushState(null, '', `/newprogram`);
                })
                .finally(() => {
                    setLoadingProgramViaPatientId(false)
                    setLoadingProgramData(false)
                });
        }
    }, [id, headerData?.patientId])




    useEffect(() => {
        props.actSidebar(true);
        var userData = JSON.parse(localStorage.getItem("userData"));
        if (userData === null) {
            props.checkLoggedIn(false);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const loadAndCreatePlan = async () => {
            const [pData, libData] = await Promise.all([mockApi.fetchProblemAreaData(), mockApi.fetchActivityLibrary()]);
            setProblemAreaData(pData);
            setActivityLibrary(libData);

        };
        if (checkDataLoaded?.ptSessions) {
            loadAndCreatePlan();
        }
    }, [
        checkDataLoaded?.ptSessions,
        problemAreas,
        subProblems,
        cpgProtocols,
        headerData?.problemArea,
        headerData?.cpgProtocol,
        headerData?.subtype
    ]);

    useEffect(() => {
        const createEmptyPlan = async () => {

            const initialPlanData = {
                weeks: []
            };
            setPlan(JSON.parse(JSON.stringify(initialPlanData)));
            setInitialPlan(JSON.parse(JSON.stringify({ ...initialPlanData, ...headerData })));
        }
        createEmptyPlan()
    }, [])

    useEffect(() => {
        if (plan && initialPlan) {
            setIsDirty(JSON.stringify({ ...plan, ...headerData }) !== JSON.stringify(initialPlan));
        }
    }, [plan, initialPlan, headerData]);

    function hasEmptyWeeks(program) {
        if (!program?.weeks || !Array.isArray(program.weeks)) return true;

        return program.weeks.some((week) =>
            week.days.every((day) =>
                !day.activities || day.activities.length === 0
            )
        );
    }

    const handleSave = (confirmAssignedProp) => {
        if (isTemplate) {
            try {
                toast.dismiss()
                if (headerData?.programName === "" || !headerData?.programName) {
                    toast.error("Please enter program name");
                    return;
                } else if (headerData?.problemId === 0 || !headerData?.problemArea) {
                    toast.error("Please select problem area");
                    return;
                } else if (headerData?.cpgProtocolId === 0 || !headerData?.cpgProtocol) {
                    toast.error("Please select cpg protocol");
                    return;
                } else if (headerData?.subtypeId === 0 || !headerData?.subtype) {
                    toast.error("Please select subtype");
                    return;
                } else if (headerData?.planLength === 0) {
                    toast.error("Please add plan week(s)");
                    return;
                } else if (headerData?.is_in_progress === 0 && hasEmptyWeeks(plan)) {
                    toast.error("Complete protocol cannot have empty weeks");
                    return;
                }

                const dataToSubmit = {
                    ...headerData,
                    ...plan
                }

                const finalTransformedDataToSubmit = transformProgramToTaskData(dataToSubmit);
                console.log(`${isTemplate ? "PROTOCOL" : "PROGRAM"} Simulating API call to save plan:`, dataToSubmit);
                console.log(`${isTemplate ? "PROTOCOL" : "PROGRAM"} TRANSFORMED DATA`, finalTransformedDataToSubmit);
                setIsSaving(true);
                axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                axios
                    .post(window.ajaxLink + "cloud_programs/save-details", {
                        programData: finalTransformedDataToSubmit,
                    })
                    .then((res) => {
                        let id = res.data.responseData.program_id;
                        // let reward = res.data.responseData.reward;
                        // setHeaderData((prev) => ({ ...prev, totalReward: reward }))
                        setProgramId(id)
                        // window.history.pushState(null, '', `/protocols/${id}`);
                        setShowSaveConfirmation(true);
                        setTimeout(() => setShowSaveConfirmation(false), 3000);
                        setInitialPlan(JSON.parse(JSON.stringify({ ...plan, ...headerData })));
                        toast.success("Protocol Saved!")
                        setIsSaving(false);
                        navigate(`/programs/tab2`)
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error("Error saving plan")
                    })
            } catch (e) {
                console.error(e)
                setIsSaving(false);
            }
        } else {
            try {
                toast.dismiss()
                if (headerData?.patientId === 0 || !headerData?.patientName) {
                    toast.error("Please select patient");
                    return;
                } else if (headerData?.programName === "" || !headerData?.programName) {
                    toast.error("Please enter program name");
                    return;
                } else if (headerData?.problemId === 0 || !headerData?.problemArea) {
                    toast.error("Please select problem area");
                    return;
                } else if (headerData?.cpgProtocolId === 0 || !headerData?.cpgProtocol) {
                    toast.error("Please select cpg protocol");
                    return;
                } else if (headerData?.subtypeId === 0 || !headerData?.subtype) {
                    toast.error("Please select subtype");
                    return;
                } else if (headerData?.planLength === 0) {
                    toast.error("Please add plan week(s)");
                    return;
                } else if (headerData?.status === "Unassigned" && confirmAssignedProp !== true) {
                    setShowUnAssignedModal(true);
                    return;
                }

                const dataToSubmit = {
                    ...headerData,
                    ...plan
                }

                const finalTransformedDataToSubmit = transformProgramToTaskData(dataToSubmit);
                console.log("Simulating API call to save plan:", dataToSubmit);
                console.log("TRANSFORMED DATA", finalTransformedDataToSubmit);

                setIsSaving(true);
                axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
                axios
                    .post(window.ajaxLink + "cloud_programs/save-details", {
                        programData: finalTransformedDataToSubmit,
                    })
                    .then((res) => {
                        let id = res.data.responseData.program_id;
                        let reward = res.data.responseData.reward;
                        if (!programId) {
                            setHeaderData((prev) => ({ ...prev, totalReward: reward }))
                            setInitialPlan(JSON.parse(JSON.stringify({ ...plan, ...headerData, totalReward: reward })));
                        } else {
                            setInitialPlan(JSON.parse(JSON.stringify({ ...plan, ...headerData })));
                        }
                        setProgramId(id)
                        window.history.pushState(null, '', `/details/${id}`);
                        // navigate(`/details/${id}`)
                        setShowSaveConfirmation(true);
                        setTimeout(() => setShowSaveConfirmation(false), 3000);
                        toast.success("Recovery Plan Saved!")
                        setIsSaving(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error("Error saving plan")
                    })
            } catch (e) {
                console.error(e)
                setIsSaving(false);
            }
        }
    };

    const handleCancel = () => {
        if (isDirty) {
            setShowCancelPrompt(true);
        }
    };

    const confirmCancel = () => {
        const { weeks, ...data } = initialPlan;
        setPlan({ weeks });
        setHeaderData(data);
        // setPlan(JSON.parse(JSON.stringify(initialPlan)));
        setShowCancelPrompt(false);
        if (pendingNavigationTarget) {
            navigate(pendingNavigationTarget);
            setPendingNavigationTarget(null);
        }
    };

    const updateHeader = (key, value) => setHeaderData(prev => ({ ...prev, [key]: value }));
    const handleDragStart = (e, item, type) => { e.dataTransfer.setData("application/json", JSON.stringify({ type, data: item })); e.dataTransfer.effectAllowed = 'move'; };

    const handleDrop = (e, dropMetadata) => {
        e.preventDefault(); e.stopPropagation();
        const payloadString = e.dataTransfer.getData("application/json");
        if (!payloadString) return;
        try {
            const payload = JSON.parse(payloadString);
            const { type: draggedType, data: draggedData } = payload;
            const { dropZone } = dropMetadata;

            if (draggedType === 'activity') {
                if (dropZone === 'day' || dropZone === 'activity') {
                    const targetDayId = dropMetadata.dayId;
                    if (draggedData.sourceDayId === targetDayId) {
                        setPlan(p => {
                            const newPlan = JSON.parse(JSON.stringify(p));
                            const day = newPlan.weeks.flatMap(w => w.days).find(d => d.id === targetDayId);
                            if (!day || isPast(day.date) || draggedData.id === dropMetadata.activityId) return p;
                            const activityIndex = day.activities.findIndex(a => a.id === draggedData.id);
                            if (activityIndex === -1) return p;
                            const [movedActivity] = day.activities.splice(activityIndex, 1);
                            const targetIndex = dropMetadata.activityId ? day.activities.findIndex(a => a.id === dropMetadata.activityId) : day.activities.length;
                            day.activities.splice(targetIndex, 0, movedActivity);
                            return newPlan;
                        });
                    } else {
                        setCopyMoveState({ isOpen: true, draggedData: draggedData, targetDayId: targetDayId });
                    }
                }
            } else if (draggedType === 'week') {
                if (dropZone === 'week') {
                    const targetWeekId = dropMetadata.weekId;
                    setPlan(p => {
                        const newPlan = JSON.parse(JSON.stringify(p));
                        const sourceWeek = newPlan.weeks.find(w => w.id === draggedData.id);
                        const targetWeek = newPlan.weeks.find(w => w.id === targetWeekId);
                        if (!sourceWeek || !targetWeek || targetWeek.days.some(d => isPast(d.date))) return p;
                        targetWeek.days.forEach((day, index) => {
                            if (!isPast(day.date)) {
                                day.activities = sourceWeek.days[index].activities.map(act => ({ ...act, id: generateUniqueId(), state: 'SCHEDULED' }));
                            }
                        });
                        return newPlan;
                    });
                }
            }
        } catch (error) { console.error("Failed to parse dropped data:", error); }
    };

    const executeMoveOrCopy = (action) => {
        const { targetDayId, draggedData } = copyMoveState;
        setPlan(p => {
            const newPlan = JSON.parse(JSON.stringify(p));
            let targetDay = newPlan.weeks.flatMap(w => w.days).find(d => d.id === targetDayId);
            if (!targetDay || isPast(targetDay.date)) return p;
            if (action === 'move') {
                let sourceDay = newPlan.weeks.flatMap(w => w.days).find(d => d.id === draggedData.sourceDayId);
                if (sourceDay) sourceDay.activities = sourceDay.activities.filter(a => a.id !== draggedData.id);
            }
            targetDay.activities.push({ ...draggedData, id: generateUniqueId() });
            return newPlan;
        });
        setCopyMoveState({ isOpen: false, draggedData: null, targetDayId: null });
    };

    const handleAddActivity = (dayId, activity) => {
        setPlan(p => {
            console.log("activityactivity", activity)
            const newPlan = JSON.parse(JSON.stringify(p));
            const day = newPlan.weeks.flatMap(w => w.days).find(d => d.id === dayId);
            if (day && !isPast(day.date)) day.activities.push({ ...activity, id: generateUniqueId(), state: 'SCHEDULED' });
            return newPlan;
        });
        toast.success(`Added "${activity?.title || "Activity"}"`)
        // if (activity?.type === "EDUCATION" || activity?.type === "QUESTIONNAIRE") {
        setPickerState({ isOpen: false, dayId: null })
        // }
    };

    const onDeleteActivity = (activityId, dayId) => { setPlan(p => { const newPlan = JSON.parse(JSON.stringify(p)); const day = newPlan.weeks.flatMap(w => w.days).find(d => d.id === dayId); if (day && !isPast(day.date)) { day.activities = day.activities.filter(a => a.id !== activityId); } return newPlan; }); };
    const handleDuplicateActivity = (activityId, dayId) => { setPlan(p => { const newPlan = JSON.parse(JSON.stringify(p)); const day = newPlan.weeks.flatMap(w => w.days).find(d => d.id === dayId); if (day && !isPast(day.date)) { const activityToCopy = day.activities.find(a => a.id === activityId); const originalIndex = day.activities.findIndex(a => a.id === activityId); if (activityToCopy && originalIndex > -1) { 
        console.log("activityToCopy", activityToCopy)
        day.activities.splice(originalIndex + 1, 0, { ...activityToCopy, is_complete: 0, is_skipped: 0, is_incomplete: 0, id: generateUniqueId(), activities: activityToCopy?.activities?.map((e) => ({...e, is_complete: 0, is_skipped: 0})) }); } } return newPlan; }); };
    const onToggleState = (activityId) => { setPlan(p => { const newPlan = JSON.parse(JSON.stringify(p)); for (const week of newPlan.weeks) { for (const day of week.days) { const activity = day.activities.find(a => a.id === activityId); if (activity) { const statesCycle = ['SCHEDULED', 'PENDING', 'COMPLETED', 'INCOMPLETE']; const currentIndex = statesCycle.indexOf(activity.state); activity.state = statesCycle[(currentIndex + 1) % statesCycle.length]; return newPlan; } } } return p; }); };


    const executeAddWeek = () => {
        setPlan(p => {
            const newPlan = JSON.parse(JSON.stringify(p));

            let weekStart;

            if (newPlan.weeks.length === 0) {
                // First ever week — start from this week's Monday
                weekStart = today;
                const day = weekStart.getDay(); // 0 = Sunday, 1 = Monday
                const diffToMonday = (day + 6) % 7;
                weekStart.setUTCDate(weekStart.getDate() - diffToMonday);
            } else {
                // Subsequent weeks — start from next Monday after last Sunday
                const lastDate = ensureDateObject(newPlan.weeks.at(-1).days[6].date); // Last week's Sunday
                weekStart = new Date(lastDate);
                weekStart.setUTCHours(11, 22, 3, 623)
                weekStart.setUTCDate(weekStart.getDate() + 1); // Go to next day

                const nextDay = weekStart.getDay();
                const daysUntilNextMonday = (8 - nextDay) % 7;
                weekStart.setUTCDate(weekStart.getDate() + daysUntilNextMonday);
            }

            // Standard time formatting
            weekStart.setUTCHours(11, 23, 3, 623);

            const newWeek = {
                id: generateUniqueId(),
                weekNumber: newPlan.weeks.length + 1,
                days: Array.from({ length: 7 }).map((_, i) => ({
                    id: generateUniqueId(),
                    date: addDays(weekStart, i).toISOString(),
                    activities: []
                }))
            };

            newPlan.weeks.push(newWeek);
            setHeaderData((prev) => ({ ...prev, planLength: newPlan?.weeks?.length }))
            return newPlan;
        });

        setTempLength(prev => prev + 1);
    };



    const executeCopyWeek = (weekId) => {
        setPlan(p => {
            const newPlan = JSON.parse(JSON.stringify(p));
            const weekToCopy = newPlan.weeks.find(w => w.id === weekId);
            if (!weekToCopy) return p;
            let lastDate = ensureDateObject(newPlan.weeks[newPlan.weeks.length - 1].days[6].date);
            const newWeekStart = addDays(lastDate, 1);
            const newWeek = { ...weekToCopy, id: generateUniqueId(), weekNumber: newPlan.weeks.length + 1, days: weekToCopy.days.map((day, i) => { const newDate = addDays(newWeekStart, i); return { ...day, id: generateUniqueId(), date: newDate.toISOString(), activities: day.activities.map(act => ({ ...act, is_complete: 0, is_skipped: 0, is_incomplete: 0, suggested_date: newDate.toISOString(), moved_date: newDate.toISOString(), id: generateUniqueId(), state: 'SCHEDULED', activities: act?.activities?.map((e) => ({...e, is_complete: 0, is_skipped: 0})) })) } }) };
            newPlan.weeks.push(newWeek);
            setHeaderData((prev) => ({ ...prev, planLength: newPlan?.weeks?.length }))
            return newPlan;
        });
        setTempLength(prev => prev + 1);
    };

    const onCopyWeek = (weekId) => {
        if (plan.weeks.length >= headerData.planLength) {
            setPendingAction({ type: 'copy', weekId });
            setExtendModalOpen(true);
        } else {
            executeCopyWeek(weekId);
        }
    };


    const handleAddWeekFlow = () => {
        if (plan.weeks.length >= headerData.planLength) {
            setPendingAction({ type: 'add' });
            setExtendModalOpen(true);
        } else {
            executeAddWeek();
        }
    };

    const confirmExtendPlan = () => {
        const startDate = new Date(headerData.startDate);
        startDate.setUTCHours(11, 22, 3, 623)
        const day = startDate.getDay();
        const diff = (day === 0 ? -6 : 1) - day;
        startDate.setDate(startDate.getDate() + diff);
        const msInWeek = 7 * 24 * 60 * 60 * 1000;
        const weeksSinceStart = Math.floor((today - startDate) / msInWeek);
        const currentPlanLength = plan.weeks.length;
        if (currentPlanLength <= weeksSinceStart) {
            const requiredLength = weeksSinceStart + 1;
            setTempLength(requiredLength);
            manualChangeWeeks(requiredLength);
        }

        if (pendingAction.type === 'add') {
            if (!(currentPlanLength <= weeksSinceStart)) {
                executeAddWeek();
            }
        } else if (pendingAction.type === 'copy') {
            executeCopyWeek(pendingAction.weekId);
        }

        setExtendModalOpen(false);
        setPendingAction({ type: null, weekId: null });
    };

    const onDeleteWeek = (weekId) => {
        setPlan(p => {
            // const weekToDelete = p.weeks.find(w => w.id === weekId);
            // if (!weekToDelete || weekToDelete.days.some(d => isPast(d.date))) return p;
            if (p.weeks.length <= 1) { setHeaderData(h => ({ ...h, planLength: 0 })); return { ...p, weeks: [] }; }
            let newWeeks = p.weeks.filter(w => w.id !== weekId).map((w, i) => ({ ...w, weekNumber: i + 1 }));
            setHeaderData(h => ({ ...h, planLength: newWeeks.length })); return { ...p, weeks: newWeeks };
        });
    };

    const manualChangeWeeks = (newLength) => {
        newLength = parseInt(newLength);
        if (isNaN(newLength) || newLength < 1) {
            toast.error(`Length cannot be less than 1.`);
            return;
        }

        const currentLength = plan.weeks.length;

        const lockedWeeks = plan.weeks.filter(week =>
            week.days.some(day => day.activities.length > 0)
        );

        const greatestLockedWeekNumber = lockedWeeks.reduce((max, week) => {
            return week.weekNumber > max ? week.weekNumber : max;
        }, 0);

        if (newLength < greatestLockedWeekNumber) {
            toast.error(`Cannot reduce below ${greatestLockedWeekNumber} week(s) with activities.`);
            setPlan(prev => {
                const newPlan = JSON.parse(JSON.stringify(prev));
                let trimmedWeeks = [...newPlan.weeks];

                while (trimmedWeeks.length > newLength) {
                    const lastWeek = trimmedWeeks[trimmedWeeks.length - 1];
                    const hasTasks = lastWeek.days.some(day => day.activities.length > 0);
                    if (hasTasks) break;
                    trimmedWeeks.pop();
                }

                // Update week numbers
                trimmedWeeks = trimmedWeeks.map((w, idx) => ({
                    ...w,
                    weekNumber: idx + 1
                }));

                // Sync actual planLength after trimming
                setHeaderData(h => ({ ...h, planLength: trimmedWeeks.length }));
                setTempLength(trimmedWeeks.length);

                return {
                    ...newPlan,
                    weeks: trimmedWeeks
                };
            });
            return;
        }

        // Add weeks if user increased
        if (newLength > currentLength) {
            const weeksToAdd = newLength - currentLength;
            for (let i = 0; i < weeksToAdd; i++) {
                executeAddWeek();
            }
            setHeaderData(h => ({ ...h, planLength: newLength }));
            return;
        }

        // Remove empty weeks from end if user decreased
        if (newLength < currentLength) {
            setPlan(prev => {
                const newPlan = JSON.parse(JSON.stringify(prev));
                let trimmedWeeks = [...newPlan.weeks];

                while (trimmedWeeks.length > newLength) {
                    const lastWeek = trimmedWeeks[trimmedWeeks.length - 1];
                    const hasTasks = lastWeek.days.some(day => day.activities.length > 0);
                    if (hasTasks) break;
                    trimmedWeeks.pop();
                }

                // Update week numbers
                trimmedWeeks = trimmedWeeks.map((w, idx) => ({
                    ...w,
                    weekNumber: idx + 1
                }));

                // Sync actual planLength after trimming
                setHeaderData(h => ({ ...h, planLength: trimmedWeeks.length }));

                return {
                    ...newPlan,
                    weeks: trimmedWeeks
                };
            });
        } else {
            // Sync unchanged or locked case
            setHeaderData(h => ({ ...h, planLength: newLength }));
        }
    };


    const hasAtLeastOneTask = plan?.weeks?.some(week =>
        week.days?.some(day => day.activities?.length > 0)
    );

    const handleNavigate = (targetPath) => {
        if (isDirty) {
            setPendingNavigationTarget(targetPath);
            setShowCancelPrompt(true); // triggers UnsavedChangesModal
        } else {
            navigate(targetPath);
        }
    };

    const [isImportProtocolDisabled, setIsImportProtocolDisabled] = useState(false);

    useEffect(() => {
        console.log("plan", plan)
        function planHasPerformedData() {
            if (!plan?.weeks?.length) return false;

            return plan.weeks.some(week =>
                week.days?.some(day =>
                    Array.isArray(day.activities) && day.activities.length > 0 && day?.activities?.some((act) =>
                        act.is_complete === 1 || act.is_incomplete === 1 || act.is_skipped === 1
                    )
                )
            );
        }

        setIsImportProtocolDisabled(planHasPerformedData())
    }, [plan])

    if (id
        &&
        (
            !checkDataLoaded.cpgProtocols
            ||
            !checkDataLoaded.subProblems
            ||
            !checkDataLoaded.problemAreas
            ||
            loadingProgramData
            ||
            !checkDataLoaded?.patients
            ||
            !checkDataLoaded?.ptSessions
            ||
            !checkDataLoaded?.problemAreas
            ||
            !plan
            ||
            !problemAreaData
            ||
            !activityLibrary
        )
    ) { return <div className="p-8 text-center text-lg font-semibold">Loading Data...</div>; }

    if (!id &&
        (
            !checkDataLoaded.cpgProtocols
            ||
            !checkDataLoaded.subProblems
            ||
            !checkDataLoaded.problemAreas
            ||
            !checkDataLoaded?.patients
            ||
            !checkDataLoaded?.ptSessions
            ||
            !checkDataLoaded?.problemAreas
            ||
            !plan
            ||
            !problemAreaData
            ||
            !activityLibrary
        )
    ) { return <div className="p-8 text-center text-lg font-semibold">Loading Planner...</div>; }

    return (
        <div style={{ position: "relative" }} className="bg-gray-100 min-h-screen font-sans p-6 new_program_screen_container">

            <nav className="text-sm text-gray-700 mb-4" aria-label="Breadcrumb">
                {
                    isTemplate ?
                        <ol className="flex items-center space-x-1 hover:text[#166273] transition-all">
                            <li onClick={() =>
                                handleNavigate("/dashboard")
                                // navigate("/dashboard")
                            } className="cursor-pointer text-lg font-semibold text-gray-900 hover:text-[#166273] text-lg font-semibold flex items-center gap-1">
                                Dashboard
                            </li>
                            <li>
                                <ChevronRight className="w-4 h-4 mx-1 text-gray-400" />
                            </li>
                            <li onClick={() =>
                                handleNavigate("/programs/tab2")
                                // navigate("/programs")
                            } className="cursor-pointer text-lg font-semibold text-gray-900 hover:text-[#166273] text-lg font-semibold flex items-center gap-1" >
                                Protocols
                            </li>
                            <li>
                                <ChevronRight className="w-4 h-4 mx-1 text-gray-400" />
                            </li>
                            <li className="text-lg font-semibold text-gray-900" aria-current="page">
                                {programId ? "Edit Protocol" : "New Protocol"}
                            </li>
                        </ol>
                        :
                        <ol className="flex items-center space-x-1 hover:text[#166273] transition-all">
                            <li onClick={() =>
                                handleNavigate("/dashboard")
                                // navigate("/dashboard")
                            } className="cursor-pointer text-lg font-semibold text-gray-900 hover:text-[#166273] text-lg font-semibold flex items-center gap-1">
                                Dashboard
                            </li>
                            <li>
                                <ChevronRight className="w-4 h-4 mx-1 text-gray-400" />
                            </li>
                            <li onClick={() =>
                                handleNavigate("/programs")
                                // navigate("/programs")
                            } className="cursor-pointer text-lg font-semibold text-gray-900 hover:text-[#166273] text-lg font-semibold flex items-center gap-1" >
                                Recovery Plans
                            </li>
                            <li>
                                <ChevronRight className="w-4 h-4 mx-1 text-gray-400" />
                            </li>
                            <li className="text-lg font-semibold text-gray-900" aria-current="page">
                                {programId ? "Edit Program" : "New Program"}
                            </li>
                        </ol>
                }
            </nav>

            {copyMoveState.isOpen && <CopyMoveModal onCopy={() => executeMoveOrCopy('copy')} onMove={() => executeMoveOrCopy('move')} onCancel={() => setCopyMoveState({ isOpen: false, draggedData: null, targetDayId: null })} />}
            {extendModalOpen && <ExtendPlanModal onConfirm={confirmExtendPlan} onCancel={() => setExtendModalOpen(false)} />}
            {showCancelPrompt && <UnsavedChangesModal onConfirm={confirmCancel} onCancel={() => setShowCancelPrompt(false)} />}
            {pickerState.isOpen && <ActivityPickerModal dayId={pickerState.dayId} onClose={() => setPickerState({ isOpen: false, dayId: null })} onAddActivity={handleAddActivity} problemArea={headerData.problemArea} problemAreaData={problemAreaData} activityLibrary={activityLibrary} onOpenViewer={setViewerItem} />}
            {viewerItem && <ViewerModal item={viewerItem} onClose={() => setViewerItem(null)} />}
            {genModalOpen && <GenerateScheduleModal onClose={() => setGenModalOpen(false)} onGenerate={() => { }} activityLibrary={activityLibrary} />}
            {editPtSession?.type && <EditPtSessionModal data={editPtSession} onOpenViewer={setViewerItem} />}
            {
                editROMTest?.type && <EditROMTestModal
                    data={editROMTest}
                    dayId={pickerState.dayId}
                    onAddActivity={handleAddActivity}
                    problemArea={headerData.problemArea}
                    problemAreaData={problemAreaData}
                    activityLibrary={activityLibrary}
                    onOpenViewer={setViewerItem} />
            }

            {/* VIEW ONLY MODALS */}
            {viewPtSession?.type && <ViewPtSessionModal data={viewPtSession} onOpenViewer={setViewerItem} onClose={() => setViewPtSession(null)} />}
            {viewRomTest?.type && <ViewRomTestModal data={viewRomTest} onOpenViewer={setViewerItem} onClose={() => setViewRomTest(null)} />}
            {showCopyModal && <CopyDayModal />}

            {/* SHOW UNASSIGNED MODAL */}
            {showUnAssignedModal && <UnassignedWarningModal onConfirm={() => {
                setShowUnAssignedModal(false);
                handleSave(true)
            }} onCancel={() => {
                setShowUnAssignedModal(false)
            }} />}

            <header className="mb-6 p-4 bg-white rounded-2xl shadow-md relative md:sticky top-0 left-0 right-0 z-20">
                <div className={
                    isTemplate ?
                        "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4"
                        :
                        "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr] gap-4"}>
                    {/* Patient Search */}
                    {
                        !isTemplate &&
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Patient</label>
                            <PatientSearchInput
                                value={headerData.patientName}
                                onChange={(v) => {
                                    updateHeader('patientId', v?.key)
                                    updateHeader('patientName', v?.value)
                                }}
                                isDirty={isDirty}
                                disabled={loadingProgramViaPatientId}
                            />
                        </div>
                    }

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Program Name</label>
                        <input
                            type="text"
                            className="w-full border border-gray-300 rounded-lg px-3 py-2"
                            value={headerData.programName}
                            onChange={(e) => updateHeader('programName', e.target.value)}
                            disabled={loadingProgramViaPatientId}
                        />
                    </div>

                    {/* Problem Area */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Problem Area</label>
                        <div className="relative">
                            <select
                                className="appearance-none form-input w-full border border-gray-300 rounded-lg px-3 py-2 pr-10" // note the pr-10 for space
                                value={headerData.problemArea}
                                onChange={(e) => {
                                    setCpgProtocols([])
                                    setSubProblems([])
                                    updateHeader('cpgProtocol', "")
                                    updateHeader('subtype', "")
                                    updateHeader('problemArea', e.target.value)
                                }}
                                disabled={loadingProgramViaPatientId}
                            >
                                {headerData.problemArea === "" && (
                                    <option value="" disabled>
                                        Select Problem Area
                                    </option>
                                )}
                                {Object.keys(problemAreaData).map((area) => (
                                    <option key={area} value={area}>
                                        {area}
                                    </option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
                        </div>
                    </div>


                    {/* CPG Protocol */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">CPG Protocol</label>
                        <div className="relative">
                            <select
                                className="form-input w-full border border-gray-300 rounded-lg px-3 py-2 pr-9"
                                value={headerData.cpgProtocol}
                                onChange={(e) => {
                                    setSubProblems([])
                                    updateHeader('subtype', "")
                                    updateHeader('cpgProtocol', e.target.value)
                                }}
                                disabled={loadingProgramViaPatientId}
                            >
                                {headerData.cpgProtocol === "" && (
                                    <option value="" disabled>
                                        Select CPG Protocol
                                    </option>
                                )}
                                {Object.keys(problemAreaData[headerData.problemArea]?.protocols || {}).map(p => (
                                    <option key={p}>{p}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
                        </div>
                    </div>

                    {/* Subtype */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Subtype</label>
                        <div className="relative">
                            <select
                                className="form-input w-full border border-gray-300 rounded-lg px-3 py-2 pr-9"
                                value={headerData.subtype}
                                onChange={(e) => updateHeader('subtype', e.target.value)}
                                disabled={loadingProgramViaPatientId}
                            >
                                {headerData.subtype === "" && (
                                    <option value="" disabled>
                                        Select Subtype
                                    </option>
                                )}
                                {headerData?.cpgProtocol && Object.keys(problemAreaData[headerData.problemArea]?.subProblems || {}).map(p => (
                                    <option key={p}>{p}</option>
                                ))}
                            </select>
                            <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" size={18} />
                        </div>
                    </div>

                    {/* Length */}
                    <div className="flex gap-3">
                        <ProgramWeeksInput
                            value={headerData.planLength}
                            onChange={(newVal) => {
                                setTempLength(newVal); // optional local state
                                setHeaderData(h => ({ ...h, planLength: newVal }));
                            }}
                            disabled={loadingProgramViaPatientId}
                            plan={plan}
                            setPlan={setPlan}
                            setHeaderData={setHeaderData}
                            executeAddWeek={executeAddWeek}
                            loadingProgram={loadingProgramViaPatientId || loadingProgramData}
                        />

                        {/* <div className="flex-[1.5]">
                            <label className="block text-sm font-medium text-gray-700 mb-1 flex flex-row gap-1">
                                <span>Reward</span>

                                <div className="text-sm font-medium text-gray-600">
                                </div>
                            </label>
                            <input
                                type="number"
                                min="0"
                                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                                value={headerData.totalReward}
                                disabled={loadingProgramViaPatientId}
                                onChange={(e) =>
                                    setHeaderData((h) => ({
                                        ...h,
                                        totalReward: parseInt(e.target.value) || 0,
                                    }))
                                }
                            />
                        </div> */}
                    </div>

                    {/* Status & Weekly Estimate */}
                    {
                        !isTemplate ?
                            <div className="flex flex-col items-center justify-center">
                                <div className={`text-sm font-medium text-gray-600 mb-1 ${programId ? "" : "opacity-[0]"}`}>
                                    (Est. reward:{' '}
                                    <span className="font-bold text-green-600">
                                        $
                                        {(() => {
                                            if (!plan?.weeks?.length) return '0.00';

                                            const activeWeeks = plan.weeks.filter(week =>
                                                week?.days?.some(day => Array.isArray(day?.activities) && day.activities.length > 0)
                                            );

                                            const weeksCount = activeWeeks.length || 1;
                                            const reward = headerData?.totalReward || 0;
                                            const perWeek = reward / weeksCount;

                                            return !isNaN(perWeek) ? perWeek.toFixed(2) : '0.00';
                                        })()}
                                        /wk)
                                    </span>
                                </div>
                                <button
                                    disabled={
                                        loadingProgramViaPatientId
                                        ||
                                        (headerData?.status === "Assigned" && isImportProtocolDisabled)
                                    }
                                    onClick={() =>
                                        updateHeader(
                                            'status',
                                            headerData.status === 'Assigned' ? 'Unassigned' : 'Assigned'
                                        )
                                    }
                                    className="w-full px-4 py-2 bg-[#166273] text-white font-semibold rounded-lg shadow hover:bg-[#166273]/90 transition disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    {headerData.status}
                                </button>
                            </div>
                            :
                            <div className="flex flex-col items-center justify-center">
                                <div className={`text-sm font-medium text-gray-600 mb-1 opacity-[0]`}>
                                    [hidden]
                                </div>
                                <button
                                    onClick={() =>
                                        updateHeader(
                                            'is_in_progress',
                                            headerData.is_in_progress === 1 ? 0 : 1
                                        )
                                    }
                                    className={`w-full px-4 py-2 text-white font-semibold rounded-lg shadow transition
                                    ${headerData.is_in_progress === 1 ? "bg-yellow-500 hover:bg-yellow-500/90" : "bg-[#166273] hover:bg-[#166273]/90"}
                                    `}
                                >
                                    {headerData.is_in_progress === 1 ? "In Progress" : "Completed"}
                                </button>
                            </div>
                    }
                </div>
            </header>

            {isTemplate ?
                <>

                    <main className="w-full">
                        {plan?.weeks?.map((week) => (
                            <WeekComponent
                                key={week.id}
                                week={week}
                                onSelectDay={(id) => { }}
                                onCopyWeek={onCopyWeek}
                                onDeleteWeek={onDeleteWeek}
                                onToggleState={onToggleState}
                                onAddActivityClick={(dayId) => setPickerState({ isOpen: true, dayId })}
                                onDeleteActivity={onDeleteActivity}
                                onDrop={handleDrop}
                                onDragStart={handleDragStart}
                                onDragEnd={() => { }}
                                onDuplicateActivity={handleDuplicateActivity}
                            />
                        ))}

                        <div className="mt-6 flex justify-end flex-col sm:flex-row gap-4">
                            <button
                                onClick={handleAddWeekFlow}
                                className="flex-1 md:flex-[0.4] flex items-center justify-center px-6 py-4 bg-white text-[#166273] font-semibold rounded-xl shadow hover:bg-gray-100 transition-all transform"
                            >
                                <Plus className="mr-2" />
                                Add a Blank Week
                            </button>
                        </div>
                    </main>

                    <footer
                        style={{ position: "sticky", bottom: 0, right: 0, zIndex: 10 }}
                        className="mt-8 flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-4 max-w-[90vw] sm:max-w-full overflow-x-auto">
                        {showSaveConfirmation && (
                            <div className="text-green-600 animate-fade-in-up text-center sm:text-right">
                                Protocol saved successfully!
                            </div>
                        )}

                        <div
                            className="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-4 overflow-x-auto w-max p-2 bg-[#F3F4F6] rounded-lg ">

                            {isDirty && (
                                <button
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                    className="flex items-center justify-center gap-2 px-6 py-3 bg-red-100 text-red-700 font-semibold rounded-lg hover:bg-red-200 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed disabled:text-white "
                                >
                                    <Ban size={18} />
                                    Cancel Changes
                                </button>
                            )}
                            <button
                                onClick={handleSave}
                                disabled={!isDirty || isSaving || !hasAtLeastOneTask}
                                className="flex items-center justify-center gap-2 px-6 py-3 bg-[#166273] text-white font-semibold rounded-lg shadow-md hover:bg-[#166273]/90 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed"
                            >
                                {isSaving ? (
                                    <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                        />
                                    </svg>
                                ) : (
                                    <Save size={18} />
                                )}
                                {isSaving ? 'Saving...' : 'Save Protocol'}
                            </button>
                        </div>
                    </footer>
                </>
                :
                <>
                    {
                        loadingProgramViaPatientId ?
                            <div className='text-center px-2 py-3 h-[100px] w-full flex flex-row items-center justify-center'
                                style={{ transform: "scale(2)" }}>
                                <svg className="animate-spin h-5 w-5 text-gray-500" viewBox="0 0 24 24" fill="none">
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    />
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                    />
                                </svg>
                            </div>
                            :
                            <>
                                <main className="w-full">
                                    {plan?.weeks?.map((week) => (
                                        <WeekComponent
                                            key={week.id}
                                            week={week}
                                            onSelectDay={(id) => { }}
                                            onCopyWeek={onCopyWeek}
                                            onDeleteWeek={onDeleteWeek}
                                            onToggleState={onToggleState}
                                            onAddActivityClick={(dayId) => setPickerState({ isOpen: true, dayId })}
                                            onDeleteActivity={onDeleteActivity}
                                            onDrop={handleDrop}
                                            onDragStart={handleDragStart}
                                            onDragEnd={() => { }}
                                            onDuplicateActivity={handleDuplicateActivity}
                                        />
                                    ))}

                                    <div className="mt-6 flex flex-col sm:flex-row gap-4">
                                        <button
                                            onClick={handleAddWeekFlow}
                                            className="flex-1 flex items-center justify-center px-6 py-4 bg-white text-[#166273] font-semibold rounded-xl shadow hover:bg-gray-100 transition-all transform"
                                        >
                                            <Plus className="mr-2" />
                                            Add a Blank Week
                                        </button>

                                        <button
                                            disabled={isImportProtocolDisabled}
                                            onClick={() => setGenModalOpen(true)}
                                            className="flex-1 flex items-center justify-center px-6 py-4 bg-[#166273] text-white font-semibold rounded-xl shadow hover:bg-[#166273]/90 transition-all transform hover:shadow-xl disabled:bg-gray-400 disabled:pointer-events-none"
                                        >
                                            <Calendar className="mr-2" />
                                            Generate from Pattern
                                        </button>
                                    </div>
                                </main>

                                <footer
                                    style={{ position: "sticky", bottom: 0, right: 0, zIndex: 10 }}
                                    className="mt-8 flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-4 max-w-[90vw] sm:max-w-full overflow-x-auto">
                                    {showSaveConfirmation && (
                                        <div className="text-green-600 animate-fade-in-up text-center sm:text-right">
                                            Plan saved successfully!
                                        </div>
                                    )}

                                    <div
                                        className="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-4 overflow-x-auto w-max p-2 bg-[#F3F4F6] rounded-lg ">
                                        {!programId &&
                                            <label className="flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
                                                <input
                                                    type="checkbox"
                                                    className="form-checkbox h-4 w-4 text-[#166273]"
                                                    onChange={(e) => {
                                                        updateHeader('saveTemplate', e.target.checked);
                                                    }}
                                                    checked={!!headerData?.saveTemplate} // ✅ always boolean
                                                />
                                                Save as Protocol
                                            </label>
                                        }

                                        {isDirty && (
                                            <button
                                                onClick={handleCancel}
                                                disabled={isSaving}
                                                className="flex items-center justify-center gap-2 px-6 py-3 bg-red-100 text-red-700 font-semibold rounded-lg hover:bg-red-200 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed disabled:text-white "
                                            >
                                                <Ban size={18} />
                                                Cancel Changes
                                            </button>
                                        )}
                                        <button
                                            onClick={handleSave}
                                            disabled={!isDirty || isSaving || !hasAtLeastOneTask}
                                            className="flex items-center justify-center gap-2 px-6 py-3 bg-[#166273] text-white font-semibold rounded-lg shadow-md hover:bg-[#166273]/90 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed"
                                        >
                                            {isSaving ? (
                                                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24" fill="none">
                                                    <circle
                                                        className="opacity-25"
                                                        cx="12"
                                                        cy="12"
                                                        r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"
                                                    />
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                    />
                                                </svg>
                                            ) : (
                                                <Save size={18} />
                                            )}
                                            {isSaving ? 'Saving...' : 'Save Recovery Plan'}
                                        </button>
                                    </div>
                                </footer>
                            </>
                    }
                </>
            }
        </div>
    );
}